import { useSubjectPropertyFieldVisibility } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldVisibility";
import { useSubjectPropertyFieldBindings } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldBindings";
export const subjectPropertyExistingMortgageBindingsAndVisibilities = existingMortgageIndex => {
  const {
    existingMortgageBalanceRemaining,
    existingMortgageBlendedAmortization,
    existingMortgageCurrentMortgageNumber,
    existingMortgageFrequency,
    existingMortgageInsured,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageInsuranceProviderId,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType,
    existingMortgageRefiAdditionalInfo,
    existingMortgageInsuranceAccountNumber
  } = useSubjectPropertyFieldBindings({
    existingMortgageIndex
  });
  const {
    propertyExistingMortgageBalanceRemainingVisible,
    propertyExistingMortgageBlendedAmortizationVisible,
    propertyExistingMortgageCurrentMortgageNumberVisible,
    propertyExistingMortgageFrequencyVisible,
    propertyExistingMortgageInsuredVisible,
    propertyExistingMortgageInterestRateVisible,
    propertyExistingMortgageLenderVisible,
    propertyExistingMortgageLoanTypeVisible,
    propertyExistingMortgageMaturityDateVisible,
    propertyExistingMortgageMortgageInsuranceProviderIdVisible,
    propertyExistingMortgageMortgageTypeVisible,
    propertyExistingMortgageOrigAmountVisible,
    propertyExistingMortgagePaymentAmountVisible,
    propertyExistingMortgagePayoffVisible,
    propertyExistingMortgageRateTypeVisible,
    propertyExistingMortgageTermTypeVisible,
    propertyExistingMortgageRefiAdditionalInfoVisible,
    propertyExistingMortgageInsuranceAccountNumberVisible,
    existingMortgagesIsVisible
  } = useSubjectPropertyFieldVisibility({
    existingMortgageIndex
  });
  return {
    bindings: {
      existingMortgageBalanceRemaining,
      existingMortgageBlendedAmortization,
      existingMortgageCurrentMortgageNumber,
      existingMortgageFrequency,
      existingMortgageInsured,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageInsuranceProviderId,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType,
      existingMortgageRefiAdditionalInfo,
      existingMortgageInsuranceAccountNumber
    },
    visibilities: {
      propertyExistingMortgageBalanceRemainingVisible,
      propertyExistingMortgageBlendedAmortizationVisible,
      propertyExistingMortgageCurrentMortgageNumberVisible,
      propertyExistingMortgageFrequencyVisible,
      propertyExistingMortgageInsuredVisible,
      propertyExistingMortgageInterestRateVisible,
      propertyExistingMortgageLenderVisible,
      propertyExistingMortgageLoanTypeVisible,
      propertyExistingMortgageMaturityDateVisible,
      propertyExistingMortgageMortgageInsuranceProviderIdVisible,
      propertyExistingMortgageMortgageTypeVisible,
      propertyExistingMortgageOrigAmountVisible,
      propertyExistingMortgagePaymentAmountVisible,
      propertyExistingMortgagePayoffVisible,
      propertyExistingMortgageRateTypeVisible,
      propertyExistingMortgageTermTypeVisible,
      propertyExistingMortgageRefiAdditionalInfoVisible,
      propertyExistingMortgageInsuranceAccountNumberVisible,
      existingMortgagesIsVisible
    }
  };
};